<template>
    <div>
        <h3>ตู้แช่ยาและเวชภัณฑ์ {{ monthlyTitle }}</h3>
        <apexchart v-if="!isLoading" type="line" height="350" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import axiosInstance from '@/utils/axiosInstance';
import VueApexCharts from 'vue3-apexcharts';
import moment from 'moment';
import 'moment/locale/th'; // Import Thai locale

export default {
    components: {
        apexchart: VueApexCharts
    },
    setup() {
        const isLoading = ref(true);  // Track loading state

        // Get the current month and year in Thai format (e.g., "มี.ค. 2568")
        const monthlyTitle = ref(moment().format('MMMM YYYY'));

        const series = ref([]);
        const chartOptions = ref({
            chart: { id: 'temperature-chart' , height: 150,},
            xaxis: {
                categories: [],
                labels: { style: { fontSize: '12px' } }
            },
            stroke: { curve: 'smooth' },
        });

        const fetchChartData = async () => {
            try {
                const response = await axiosInstance.get('/mc/records-per-day');
                const data = response.data;

          
                moment.locale('th'); // Set Thai locale

                if (data && data.length > 0) {
                    // Map the data and format the date as '1 มี.ค.', '2 มี.ค.'
                    chartOptions.value.xaxis.categories = data.map(item => {
                        const formattedDate = moment(item.date).format('D MMM');
                        return formattedDate;
                    });

                    // Set the series data
                    series.value = [{
                        name: 'จำนวนบันทึก',
                        data: data.map(item => item.count),
                    }];
                } else {
                    console.warn('No data found for chart');
                }
                
                // Set loading state to false after data is loaded
                isLoading.value = false;
            } catch (error) {
                console.error('Error fetching chart data:', error);
            }
        };

        onMounted(fetchChartData);

        return { series, chartOptions, monthlyTitle, isLoading };
    }
};
</script>